import styled from 'styled-components';
import {BUTTON_STYLES, ROUTER_STYLES, TAB_STYLES} from './styles';
import {ButtonProps, CommonProps, RouterButtonProps, TabProps} from './types';
import {NavLink} from 'react-router-dom';

export const Button = styled.button<CommonProps & ButtonProps>`
  ${BUTTON_STYLES}
`;

export const RouterLink = styled(NavLink)<CommonProps & RouterButtonProps>`
  ${ROUTER_STYLES}
`;

export const TabButton = styled.button<CommonProps & TabProps>`
  ${TAB_STYLES}
`;
